/** Shared short-payment / hold reason options for invoice payment & status update. */
export const SHORT_PAYMENT_REASONS = [
  { value: null, text: 'Select reason' },
  { value: 'gst_hold', text: 'GST Hold' },
  { value: 'tds_hold', text: 'TDS Hold' },
  { value: 'both_gst_tds_hold', text: 'Both GST & TDS Hold' },
  { value: 'client_deduction_other', text: 'Client Deduction / Other' }
]

export function getShortPaymentReasonLabel(code) {
  const opt = SHORT_PAYMENT_REASONS.find(o => o.value && o.value === code)
  return opt ? opt.text : ''
}

/** Prefix notes with `[Reason Label]` when a short-payment reason is selected. */
export function buildNotesWithShortPaymentReason(notes, reasonLabel) {
  const trimmed = (notes || '').trim()
  if (!reasonLabel) return trimmed
  const tag = `[${reasonLabel}]`
  if (trimmed.startsWith(tag)) return trimmed
  return trimmed ? `${tag} ${trimmed}` : tag
}

/**
 * True when paid/payment amount is short of the comparison amount by more than 1 paise.
 * @param {number|string} amount
 * @param {number|string} compareAgainst outstanding (record payment) or invoice total (status update)
 */
export function isShortPaymentAmount(amount, compareAgainst) {
  const amt = Number(amount)
  const against = Number(compareAgainst)
  if (isNaN(amt) || amt <= 0 || isNaN(against)) return false
  return amt < (against - 0.009)
}
